import { render, staticRenderFns } from "./GeneralInfoReport.vue?vue&type=template&id=edfb6dd2&scoped=true"
import script from "./GeneralInfoReport.vue?vue&type=script&lang=js"
export * from "./GeneralInfoReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoReport.vue?vue&type=style&index=0&id=edfb6dd2&prod&scoped=true&lang=css"
import style1 from "./GeneralInfoReport.vue?vue&type=style&index=1&id=edfb6dd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfb6dd2",
  null
  
)

export default component.exports